export default "__VITE_ASSET__91547734__"